module.exports = __webpack_public_path__ + "media/warning.ab2896d7.mp3";